import type { LowStockItemRow } from "@/modules/inventory/domain/types";
import { stockPolicyItemTypeLabel } from "@/modules/inventory/presentation/ui/stock-policy/stockPolicyLaoLabels";

function csvCell(value: unknown) {
  return `"${String(value ?? "").replace(/"/g, '""')}"`;
}

function csvRow(cells: unknown[]) {
  return cells.map(csvCell).join(",");
}

export function downloadLowStockReportCsv(
  items: LowStockItemRow[],
  meta?: { branchCode?: string },
) {
  const headers = [
    "ສາຂາ",
    "ປະເພດ",
    "ລາຍການ",
    "ຫນ່ວຍ",
    "ຄົງເຫຼືອ",
    "ຂັ້ນຕ່ຳ",
    "ເປົ້າເຕີມ",
    "ແຫຼ່ງເກັນໄຂ",
  ];

  const rows = items.map((row) =>
    csvRow([
      row.branchCode,
      stockPolicyItemTypeLabel(row.itemType),
      row.itemName,
      row.unit,
      row.onHand,
      row.minQty,
      row.effectiveTargetQty,
      row.policySource === "branch" ? "ສາຂາ" : "global",
    ]),
  );

  const title = meta?.branchCode
    ? csvRow([`ລາຍງານຕ່ຳກວ່າເງື່ອນໄຂ — ${meta.branchCode}`, items.length])
    : csvRow(["ລາຍງານຕ່ຳກວ່າເງື່ອນໄຂ", items.length]);

  const csv = [title, "", csvRow(headers), ...rows].join("\n");

  const blob = new Blob(["\uFEFF" + csv], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `low-stock-${meta?.branchCode ?? "report"}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
